import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getPolicyDetail } from '@/api/getPolicyDetail';
import { Banner } from '@/app/(allowed)/policy/[id]/_components/Banner';
import { PolicyContent } from '@/app/(allowed)/policy/[id]/_components/PolicyContent';
import { PolicyHeader } from '@/app/(allowed)/policy/[id]/_components/PolicyHeader';
interface PolicyDialogContentProps {
  policyIdIdx?: string;
}
export const PolicyDialogContent = t0 => {
  const $ = _c(12);
  const {
    policyIdIdx
  } = t0;
  let t1;
  let t2;
  if ($[0] !== policyIdIdx) {
    t1 = ["getPolicyDetail", policyIdIdx];
    t2 = () => getPolicyDetail(policyIdIdx as string);
    $[0] = policyIdIdx;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = !!policyIdIdx;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      placeholderData: keepPreviousData
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data,
    status
  } = useQuery(t4);
  switch (status) {
    case "pending":
      {
        let t5;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <PendingContent />;
          $[7] = t5;
        } else {
          t5 = $[7];
        }
        return t5;
      }
    case "success":
      {
        let t5;
        if ($[8] !== data || $[9] !== policyIdIdx) {
          t5 = data && policyIdIdx ? <><PolicyHeader data={data} policyIdIdx={policyIdIdx} /><Banner idx={policyIdIdx} policyBannerTypeList={data.policyBannerTypeList} /><PolicyContent data={data} /></> : null;
          $[8] = data;
          $[9] = policyIdIdx;
          $[10] = t5;
        } else {
          t5 = $[10];
        }
        return t5;
      }
    case "error":
      {
        let t5;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <p className="text-center text-Gray-600">에러가 발생했습니다.</p>;
          $[11] = t5;
        } else {
          t5 = $[11];
        }
        return t5;
      }
  }
  return null;
};
const PendingContent = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-8"><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /><Skeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};